import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const NEP2020 = () => {
  const homeMenu = [
    { label: "MUN", link: "/Mun" },
    { label: "Glory to the Nation", link: "/GloryOfNation" },

    {
      label: "Spic Macay Cultural and Heritage Club",
      link: "/SpocmacyColtoralHeritage",
    },
    {
      label: "Vocational Education Clubs (Middle Wing) ",
      link: "/vocationalClubmiddle",
    },
    {
      label: "Vocational Education Clubs (Senior Wing)",
      link: "/vocationalClub",
    },
    {
      label: "Vocational Education Clubs (Primary Wing)",
      link: "/VocationalClubPrimary",
    },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/blog-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="MUN:Model United Nations"
                breadEnd="MUN:Model United Nations"
                breadMid="MUN:Model United Nations"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>
                Model United Nations conferences provide students with a
                platform to unleash their diplomatic and communication skills
                through the simulation of various committees of the United
                Nations.
              </p>
            </div>
            <div className="col-md-12">
              <div class="blog-main-box">
                <div class="blogList">
                  <div class="blog-img">
                    <iframe
                      src="https://www.youtube.com/embed/4fND0B9Rm8Y"
                      title="MUN"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen=""
                    ></iframe>
                  </div>
                  <div class="blog-text">
                    <h2 className="color-red"> MUN</h2>
                    <p>
                      Lotus Valley International School achieved yet another
                      milestone by successfully organizing the Virtual Inter
                      School LOTUSMUN2020:Dream . Discover . Conquer (Model
                      United Nations) on 11th July 2020. The conference
                      attracted 350 delegates across the globe, including
                      countries like Russia, Australia and Switzerland and 14
                      Indian schools. Optimism is the major driving force of
                      this LOTUSMUN2020 and we hope that this next generation of
                      diplomats and leaders will remember LOTUSMUN2020 as one of
                      the moments that sharpened their view for global issues
                      and expanded their horizon. Because in the end, it is “the
                      youth of this world, that can make a difference!
                    </p>
                  </div>
                </div>
              </div>
              <div class="blog-main-box">
                <div class="blogList">
                  <div class="blog-img">
                    <iframe
                      src="https://www.youtube.com/embed/dpahHKZ4JN8"
                      title="Carpe Diem'19"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen=""
                    ></iframe>
                  </div>
                  <div class="blog-text">
                    <h2 className="color-red">Carpe Diem'19</h2>
                    <p> When Your Voice Matters</p>
                    <p>
                      {" "}
                      Lotus Valley International School Gurugram organized the
                      Intra-School Model United Nations Conference ‘Carpe
                      Diem-Seize the day when your voice matters’ on Sunday,
                      18th August, 2019, from grades VIII-XII.{" "}
                    </p>
                    <p>
                      ‘Carpe Diem’ aimed to be an MUN conference where learners
                      debated, contemplated and deliberated effectively on
                      various global issues throughout their committee sessions
                      and press conferences under the guidance of the
                      experienced Executive Board and Secretariat members.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div class="blog-main-box">
                <div class="blogList">
                  <div class="blog-img">
                    <iframe
                      src="https://www.youtube.com/embed/SU7bzfijmfU"
                      title="Opening Ceremony"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen=""
                    ></iframe>
                  </div>
                  <div class="blog-text">
                    <h2 className="color-red">Opening Ceremony</h2>
                    <p>
                      LotusMUN’21-’Redefining the Norm’ began with supreme verve
                      and vigour to find feasible solutions for the problems at
                      hand. The world leaders at the United Nations General
                      Assembly wrote working papers to deeply analyse the issue
                      of intolerance and provide apt solutions for the same,
                      while delegates in the United Nations Commission for the
                      Status of Women decided to reach a joint conclusion over
                      the agenda given. The United Nations Security Council
                      convened to find ways of restoring peace in Myanmar after
                      the coup d'état of 1st February, 2021. The Indian
                      politicians in Lok Sabha discussed the future of India’s
                      economy post pandemic. Meanwhile, in Indian War Cabinet,
                      government officials took diplomatic and military action
                      against the PLA around the McMahon Line. Furthermore,
                      editors-in chief of EU countries congregated in European
                      Commission on Ethical Journalism and Reporting and framed
                      a mandate for the release of sensitive information
                      regarding governance, trade ties and military. In the
                      Union of European Football Association, football clubs
                      agreed to transfer funds from the men’s football clubs to
                      the women’s; meanwhile countries in the International
                      Organisation of Securities Council, deliberated the
                      implications of short selling and market manipulation
                      through social media.
                    </p>
                    <p>
                      LotusMUN’21 was a grand success, one that the Secretariat
                      was extremely proud of. Though exhausted, the delegates
                      still brimmed with pride and joy on putting their best
                      foot forward. The journey of LotusMUN’21-’Redefining the
                      Norm’ might have ended, but the learning hasn’t.
                    </p>
                  </div>
                </div>
              </div>
              <div class="blog-main-box">
                <div class="blogList">
                  <div class="blog-img">
                    <iframe
                      src="https://www.youtube.com/embed/G9bpL50BHUA"
                      title="Closing Ceremony"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen=""
                    ></iframe>
                  </div>
                  <div class="blog-text">
                    <h2 className="color-red">Closing Ceremony</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default NEP2020;
